import { render, staticRenderFns } from "./selectCreateSeverDialog.vue?vue&type=template&id=4b232956&scoped=true&"
import script from "./selectCreateSeverDialog.vue?vue&type=script&lang=js&"
export * from "./selectCreateSeverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b232956",
  null
  
)

export default component.exports